<template>
  <div style="position: relative;width: 100vw;height: 100vh;background: rgba(15, 20, 25, 1);">
    <TopShareBar/>
    <img src="@/assets/SatelliteActivityShoot/rights.png" style="width: 300px;margin-top: 100px;margin-left: calc(50vw - 150px)"/>
    <div @click="register" style="width: 192px;height: 48px;margin-left: calc(50vw - 96px);margin-top: 27px;border-radius: 24px;display: flex;align-items: center;justify-content: center;background: linear-gradient(90deg, rgba(74, 154, 255, 1) 0%, rgba(92, 222, 255, 1) 100%)">
      <div  style="width: 190px;height: 46px;;border-radius: 24px;background: rgba(15, 20, 25, 1);display: flex;align-items: center;justify-content: center;">
        <div class="gradient-text">立即注册</div>
      </div>
    </div>
    <div class="element" style="width: 192px;height: 48px;">立即注册</div>
    <img src="@/assets/SatelliteActivityShoot/hand.png" style="position: absolute;bottom: 0;left: 0;width: 300px"/>
  </div>
</template>

<script>
import TopShareBar from "@/components/TopShareBar.vue";

export default {
  name: 'SatelliteActivityRegisterShare',
  components: {TopShareBar},
  data() {
    return {

    }
  },
  methods: {
    register() {
      this.$router.push({
        path: '/ActivityLogin',
        query: {
          inviteId: this.$route.query.inviteId
        }
      })
    },
  },
  mounted() {
    document.title = '快来一起玩转共生地球'
  }
}
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(90deg, rgba(74, 154, 255, 1) 0%, rgba(92, 222, 255, 1) 100%); /* 渐变颜色 */
  -webkit-background-clip: text; /* 将背景裁剪为文字形状 */
  background-clip: text;
  color: transparent; /* 设置文字颜色为透明 */
}
</style>